import { useQuery } from "@tanstack/react-query";
import { sessionQueryOptions } from "@/api-queries/auth";

export function useAuth() {
  const { data: session, isLoading } = useQuery(sessionQueryOptions());

  return {
    session,
    user: session?.user ?? null,
    isLoading,
    isAuthenticated: !!session?.user,
  };
}
